import {Col, Row, Stack} from 'react-bootstrap'
import Dropdown from '../../../sharedComponent/Dropdown/Dropdown'
import BillingAddressInfo from './steps/BillingAddressInfo'
import ServiceAddressInfo from './steps/ServiceAddressInfo'
import {alert} from '../../../../utils/helper'
import {useState} from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {format, parse} from 'date-fns'
export default function FormFields({
  formik,
  hasFieldError,
  isCommercialCustomer,
  setIsCommercialCustomer,
  customerType,
  inputRef,
  handleOnChecked,
  isServiceSameAsBill,
  billingRef,
  businessRef,
  setDocumentDelivery,
  featureFlags,
  sendContract,
  setSendContract,
  sendContractEmail,
  setSendContractEmail,
  mode,
  customerFeatureFlags,
  isOptedIn,
  triggerOptinAlert,
  setUtilities,
  sendContractMessgae,
  setSendContractMessage,
  isSolarProduct,
}: any) {
  const formatDateForBackend = (date: Date) => format(date, 'MM/dd/yyyy')
  // Parse the backend date (mm/dd/yy) into a Date object for the DatePicker
  const parseDateFromBackend = (dateString: string) => parse(dateString, 'MM/dd/yyyy', new Date())
  const handleSelectedItem = (e: any, name: any) => {
    formik.setFieldTouched(name, true)
    if (e.value.length > 0) {
      formik.setFieldValue(`${name}Id`, e.value)
      formik.setFieldValue(name, e.label)
      const getCustomerType = e.label.includes('Residential')
      if (!getCustomerType) {
        setIsCommercialCustomer(true)
      } else {
        setIsCommercialCustomer(false)
      }
      console.log(getCustomerType, e.label, 'new custmoer')
    } else {
      formik.setFieldValue(`${name}Id`, null)
      formik.setFieldValue(name, '')
    }
  }
  return (
    <>
      <Row
        className='d-flex align-items-end mt-5 no-gutters noPadding'
        style={{marginBottom: '20px'}}
      >
        <Col sm={6} md={6} className='mr-0 ml-0 pb-5'>
          <label className='d-flex align-items-center mb-2'>
            <span
              className={`fs-6 fw-semibold lh-23px ${!isCommercialCustomer && 'text-gray-400'}`}
            >
              Business Name
            </span>
          </label>
          <input
            id='businessName'
            type='text'
            ref={businessRef}
            className='form-control form-control-lg form-control-solid'
            name='businessName'
            placeholder='Enter business name'
            readOnly={!isCommercialCustomer}
            maxLength={51}
            {...formik.getFieldProps('businessName')}
          />
          {formik.errors.businessName && hasFieldError && (
            <div className='fv-plugins-message-container' style={{width: '235px'}}>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                {formik.errors.businessName}
              </div>
            </div>
          )}
        </Col>
        <Col sm={6} md={6} className='mr-0 ml-0 pb-5'>
          <label className='d-flex align-items-center mb-2 required'>
            <span className='fs-6 fw-semibold lh-23px'>Customer Type</span>
          </label>
          <Dropdown
            fieldName='customerType'
            optionList={customerType}
            handleSelectedItem={handleSelectedItem}
            formik={formik}
          />
        </Col>
      </Row>
      <Row
        className='d-flex align-items-end mt-5 no-gutters noPadding'
        style={{marginBottom: '20px'}}
      >
        <Col sm={6} md={6} className='mr-0 ml-0 pb-5'>
          <label className='d-flex align-items-center mb-2 required'>
            <span className='fs-6 fw-semibold lh-23px'>First Name</span>
          </label>
          <input
            id='customerFirstName'
            ref={inputRef}
            type='text'
            className='form-control form-control-lg form-control-solid'
            name='customerFirstName'
            placeholder='Enter first name'
            maxLength={51}
            {...formik.getFieldProps('customerFirstName')}
          />
          {formik.errors.customerFirstName && hasFieldError && (
            <div className='fv-plugins-message-container'>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                {formik.errors.customerFirstName}
              </div>
            </div>
          )}
        </Col>
        <Col sm={6} md={6} className='mr-0 ml-0 pb-5'>
          <label className='d-flex align-items-center mb-2'>
            <span className='fs-6 fw-semibold lh-23px'>Last Name</span>
          </label>
          <input
            id='customerLastName'
            type='text'
            className='form-control form-control-lg form-control-solid'
            name='customerLastName'
            placeholder='Enter last name'
            maxLength={51}
            {...formik.getFieldProps('customerLastName')}
          />
          {formik.errors.customerLastName && hasFieldError && (
            <div className='fv-plugins-message-container' style={{width: '235px'}}>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                {formik.errors.customerLastName}
              </div>
            </div>
          )}
        </Col>
      </Row>
      {isSolarProduct && (
        <Row
          className='d-flex align-items-end mt-5 no-gutters noPadding'
          style={{marginBottom: '20px'}}
        >
          <Col sm={4} md={4} className='mr-0 ml-0 pb-5'>
            <label className='d-flex align-items-center mb-2 required'>
              <span className='fs-6 fw-semibold lh-23px'>Date Of Birth</span>
            </label>

            <DatePicker
              className='form-control form-control-solid ps-6'
              id='dateOfBirth'
              selected={
                formik.getFieldProps('dateOfBirth').value
                  ? parseDateFromBackend(formik.getFieldProps('dateOfBirth').value)
                  : null
              }
              onChange={(val) => {
                if (val) {
                  formik.setFieldValue('dateOfBirth', formatDateForBackend(val))
                } else {
                  formik.setFieldValue('dateOfBirth', '')
                }
              }}
              dateFormat='MM-dd-yyyy'
              autoComplete='off'
              placeholderText='MM-DD-YYYY'
              onChangeRaw={(e) => e.preventDefault()} // Prevent manual input
              maxDate={new Date()} // Restrict future dates
              showYearDropdown // Enables a year dropdown
              scrollableYearDropdown // Allows scrolling through years
              yearDropdownItemNumber={150} // Show 100 years in dropdown
              onBlur={(e) => {
                const dateValue = e.target.value
                const parsedDate = Date.parse(dateValue)

                if (isNaN(parsedDate) || new Date(parsedDate) > new Date()) {
                  formik.setFieldValue('dateOfBirth', '') // Reset invalid input
                }
              }}
            />
            {formik.errors.dateOfBirth && hasFieldError && (
              <div className='fv-plugins-message-container' style={{width: '235px'}}>
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  {formik.errors.dateOfBirth}
                </div>
              </div>
            )}
          </Col>
        </Row>
      )}

      <Stack className='mt-5 mb-5' gap={3}>
        <label className='d-flex align-items-center fs-5 fw-bold mb-4 lh-1'>
          <span>Service Address</span>
        </label>
        <ServiceAddressInfo
          formik={formik}
          hasFieldError={hasFieldError}
          featureFlags={featureFlags}
          setUtilities={setUtilities}
        />
      </Stack>
      <div className='mb-10'>
        <div className='form-check form-check-custom form-check-solid'>
          <input
            className='form-check-input'
            type='checkbox'
            value=''
            id='flexCheckDefault'
            checked={isServiceSameAsBill}
            onChange={handleOnChecked}
          />
          <label className='form-check-label' htmlFor='flexCheckDefault'>
            Billing address is the same as the service address
          </label>
        </div>
      </div>
      <Stack className='mt-5 mb-5' gap={3}>
        <label className='d-flex align-items-center fs-5 fw-bold mb-4 lh-1'>
          <span>Billing Address</span>
        </label>
        <BillingAddressInfo
          formik={formik}
          hasFieldError={hasFieldError}
          isServiceSameAsBill={isServiceSameAsBill}
          billingRef={billingRef}
          featureFlags={featureFlags}
        />
        <div className='fv-row '>
          <div className='mb-5'>
            <label className='d-flex align-items-center mb-2'>
              <span className='fs-6 fw-semibold'>Document Delivery</span>
            </label>
            <div className='form-check form-check-custom form-check-solid form-check-sm'>
              <input
                className='form-check-input'
                name='documentDelivery'
                type='radio'
                value='MAIL'
                id='flexRadioSm'
                checked={formik.values.documentDelivery === 'MAIL'}
                onChange={(e) => {
                  setDocumentDelivery(e.target.value)
                  formik.setFieldValue('documentDelivery', 'MAIL')
                }}
              />
              <label className='form-check-label me-3' htmlFor='flexRadioSm'>
                Mail
              </label>
              <input
                className='form-check-input'
                name='documentDelivery'
                type='radio'
                value='EMAIL'
                id='flexRadioSm'
                checked={formik.values.documentDelivery === 'EMAIL'}
                disabled={formik.values.customerEmailId === ''}
                onChange={(e) => {
                  setDocumentDelivery(e.target.value)
                  formik.setFieldValue('documentDelivery', 'EMAIL')
                }}
              />
              <label className='form-check-label me-3' htmlFor='flexRadioSm'>
                Email
              </label>

              <input
                className='form-check-input'
                name='documentDelivery'
                type='radio'
                value='TEXT'
                id='flexRadioSm'
                checked={formik.values.documentDelivery === 'TEXT'}
                onChange={(e) => {
                  setDocumentDelivery(e.target.value)
                  formik.setFieldValue('documentDelivery', 'TEXT')
                }}
              />
              <label className='form-check-label me-3' htmlFor='flexRadioSm'>
                Text
              </label>
            </div>
          </div>
        </div>
        <div className='mb-10'>
          {mode === 'create' &&
            customerFeatureFlags?.getCustomerFeatureFlag?.enableEmailDocumentVerification && (
              <>
                <div className='form-check form-check-custom form-check-solid d-inline-block me-3'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    checked={sendContractEmail}
                    onChange={() => {
                      if (formik.values.customerEmailId === '') {
                        alert('Please enter the email Id', 'error')
                      } else {
                        setSendContractEmail((prev: any) => !prev)
                        formik.setFieldValue('contractbyEmail', !sendContractEmail)
                        !sendContractEmail
                          ? setSendContractMessage('')
                          : setSendContractMessage('Contract type required')
                      }
                      if (sendContractEmail && formik.values.tpvType === 'SMS TPV') {
                        formik.setFieldValue('tpvType', '')
                      }
                    }}
                    id='flexCheckEmail'
                  />
                  <label className='form-check-label' htmlFor='flexCheckEmail'>
                    Send contract by Email
                  </label>
                </div>
              </>
            )}
          {mode === 'create' &&
            customerFeatureFlags?.getCustomerFeatureFlag?.enableSmsDocumentVerification && (
              <>
                <div className='form-check form-check-custom form-check-solid d-inline-block me-3'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    checked={sendContract}
                    onChange={() => {
                      if (isOptedIn) {
                        setSendContract((prev: any) => !prev)
                        formik.setFieldValue('contractbySms', !sendContract)
                        !sendContract
                          ? setSendContractMessage('')
                          : setSendContractMessage('Contract type required')
                      } else {
                        triggerOptinAlert()
                      }
                    }}
                    id='flexCheckSms'
                  />
                  <label className='form-check-label' htmlFor='flexCheckSms'>
                    Send contract by SMS
                  </label>
                </div>
              </>
            )}

          {/* Generic error display when both features are enabled */}
          {/* {sendContractMessgae && (
            <div className='fv-plugins-message-container' style={{width: '235px'}}>
              <div data-field='genericError' data-validator='notEmpty' className='fv-help-block'>
                {sendContractMessgae}
              </div>
            </div>
          )} */}
        </div>
      </Stack>
    </>
  )
}
